import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full min-h-[300px]"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-textSecondary" }, "Não foi possível carregar os detalhes do pedido.", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "flex flex-col gap-y-6 text-textPrimary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-md font-bold text-left",
  "data-testid": "request-summary-title"
}, " Resumo do pedido ", -1)
const _hoisted_7 = { class: "grid grid-cols-2 gap-x-4 gap-y-6" }
const _hoisted_8 = {
  class: "text-left",
  "data-testid": "request-summary-date"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Data da solicitação", -1)
const _hoisted_10 = { class: "mt-1 text-base" }
const _hoisted_11 = {
  class: "text-left",
  "data-testid": "request-summary-requester"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Solicitante", -1)
const _hoisted_13 = { class: "mt-1 text-base" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-x-4 gap-y-6" }
const _hoisted_15 = {
  class: "text-left",
  "data-testid": "request-summary-approval-date"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Data da aprovação", -1)
const _hoisted_17 = { class: "mt-1 text-base" }
const _hoisted_18 = {
  class: "text-left",
  "data-testid": "request-summary-approvers"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Aprovadores", -1)
const _hoisted_20 = { class: "mt-1 text-base" }
const _hoisted_21 = {
  key: 1,
  class: "text-left",
  "data-testid": "request-summary-pending-approvers"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Aprovadores pendentes", -1)
const _hoisted_23 = { class: "mt-1 text-base" }
const _hoisted_24 = {
  key: 1,
  class: "grid grid-cols-2 gap-x-4 gap-y-6"
}
const _hoisted_25 = { class: "text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Data da solicitação", -1)
const _hoisted_27 = { class: "mt-1 text-base" }
const _hoisted_28 = { class: "text-left" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "ID da solicitação", -1)
const _hoisted_30 = { class: "mt-1 text-base" }
const _hoisted_31 = { class: "text-left" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Status", -1)
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Solicitante", -1)
const _hoisted_35 = { class: "mt-1 text-base" }
const _hoisted_36 = {
  key: 0,
  class: "text-left"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Aprovador", -1)
const _hoisted_38 = { class: "mt-1 text-base" }
const _hoisted_39 = {
  key: 1,
  class: "text-left"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Data da Aprovação", -1)
const _hoisted_41 = { class: "mt-1 text-base" }
const _hoisted_42 = { class: "text-left" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold" }, "Justificativa do Solicitante", -1)
const _hoisted_44 = { class: "mt-1 text-base leading-relaxed" }
const _hoisted_45 = {
  key: 3,
  class: "flex flex-col gap-y-4 mt-4 pb-4"
}
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_48 = {
  key: 0,
  class: "bg-warning/20 border border-warning rounded-lg p-3 text-sm text-yellow-800 mb-4",
  "data-testid": "no-available-roles-message"
}
const _hoisted_49 = {
  key: 1,
  class: "flex flex-col gap-y-2 mb-4",
  "data-testid": "role-selector"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold text-left" }, "Aprovar como", -1)
const _hoisted_51 = { class: "flex gap-x-2" }
const _hoisted_52 = {
  key: 2,
  class: "text-center text-sm text-textSecondary my-4"
}
const _hoisted_53 = {
  key: 3,
  class: "flex items-start gap-2 px-3 py-2 my-4 rounded-md border border-primary30 bg-primary5 text-sm text-textPrimary text-left",
  "data-testid": "request-exception-post-station-lock-banner"
}
const _hoisted_54 = {
  key: 4,
  class: "flex justify-around gap-4 mt-2"
}

import { computed, ref, watch, watchEffect } from 'vue'
import { useToast } from 'vue-toastification'
import DOMPurify from 'dompurify'
import { getApiErrorMessage } from '@/utils/apiError'
import { useErrorToast } from '@/composables/useErrorToast'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'

import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import TextareaInput from '../Textarea/TextareaInput.vue'
import StatusBadge from '../Badges/StatusBadge.vue'

import DropdownCard from '../Cards/DropdownCard.vue'
import ApprovalChoice from '../Cards/ApprovalChoice.vue'
import ExceptionConfirmationSidebar from './ExceptionConfirmationSidebar.vue'
import StationContextCard from '../Cards/StationContextCard.vue'
import ExceptionalityProgressTimeline from '@/modules/company/Approvals/AuditoriumExceptionalities/components/ExceptionalityProgressTimeline.vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { POST_STATION_LOCK_BANNER_TEXT } from '@/modules/company/PostStation/constants'
import {
  getPostStationApprovedMessage,
  isPostStationApprovedError
} from '@/modules/company/PostStation/errors'
import { mapApprovalToTimeline } from '@/utils/approval-timeline-mapper'

import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

import ExceptionService from '@/Network/Services/DoctorStationException'
import {
  ExceptionStatusEnum,
  type ExceptionSummary,
  ModalActionType
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'

import { formatDateToString, formatDateTimeWithTimezone } from '@/utils/date'
import { formatCurrency, formatProportionalityRule, formatRepassMode } from '@/utils/formatters'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { ValidationRole, VALIDATION_ROLE_LABELS } from '@/types/approval-flow.types'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

type ApprovalStatusOption = 'approved' | 'rejected' | null
type ApprovalStatus = 'Approved' | 'Rejected' | null

interface EvaluationItem {
  id: string
  title: string
  icon: string
  details: string
  approvalStatus: ApprovalStatusOption
  analystJustification: string
}

export interface ApprovalStatusMap {
  financials: ApprovalStatus
  repassMode: ApprovalStatus
  proportionalityRule: ApprovalStatus
  workJourney: ApprovalStatus
}

interface StationContextData {
  doctorName: string
  doctorCrm?: string
  scheduleName: string
  positionName: string
  shiftName?: string
  team?: string
  timeRange: string
  dutyType?: string
  value?: string
  formation?: string
  repassMode?: string
  proportionalityRule?: string
  breadcrumb?: string
  allocatedBy?: string
  startDetail?: string
  endDetail?: string
  timezone?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestExceptionalitySidebar',
  props: {
    isOpen: { type: Boolean },
    exceptionId: {},
    scheduleId: {},
    stationContext: {},
    postStationLocked: { type: Boolean, default: false }
  },
  emits: ["update:isOpen", "submitSuccess", "status-map-changed"],
  setup(__props: any, { emit }) {

const props = __props;





const toast = useToast()
const { notifyError } = useErrorToast()
const exceptionService = new ExceptionService()
const permissionsStore = usePermissionsStore()
const { flags } = useFeatureFlags()

const detailedException = ref<ExceptionSummary | null>(null)
const loading = ref(false)
const isSubmitting = ref(false)
const isConfirmModalOpen = ref(false)
const currentConfirmActionType = ref<ModalActionType>(ModalActionType.REJECT)
const evaluationItems = ref<EvaluationItem[]>([])

const resetState = () => {
  detailedException.value = null
  evaluationItems.value = []
  loading.value = false
  isSubmitting.value = false
  isConfirmModalOpen.value = false
  selectedRole.value = null
}

const isSidebarOpen = computed({
  get: () => props.isOpen,
  set: (value) => emit('update:isOpen', value)
})

const allAreApproved = computed(() => {
  if (evaluationItems.value.length === 0) return false
  return evaluationItems.value.every((item) => item.approvalStatus === 'approved')
})

const isAwaitingApproval = computed(
  () => detailedException.value?.status === ExceptionStatusEnum.AWAITING_APPROVAL
)

const approvedApproversText = computed(() => {
  const decisions = detailedException.value?.approvalInstance?.decisions
  if (!decisions) return ''
  return decisions
    .filter((d) => d.decision === 'APPROVED' && d.userName)
    .map((d) => d.userName)
    .join(', ')
})

const pendingApproversText = computed(() => {
  const instance = detailedException.value?.approvalInstance
  if (!instance) return ''

  const pendingDecisions = instance.decisions.filter((d) => d.decision === 'PENDING')
  if (pendingDecisions.length === 0) return ''

  const operatorByOrder = new Map(instance.layers.map((l) => [l.order, l.operator]))

  const byLayer = new Map<number, string[]>()
  for (const d of pendingDecisions) {
    const label = VALIDATION_ROLE_LABELS[d.role as ValidationRole] ?? d.role
    if (!byLayer.has(d.layerOrder)) byLayer.set(d.layerOrder, [])
    byLayer.get(d.layerOrder)!.push(label)
  }

  const layerTexts: string[] = []
  for (const [order, labels] of [...byLayer.entries()].sort((a, b) => a[0] - b[0])) {
    const separator = operatorByOrder.get(order) === 'OR' ? ' ou ' : ' e '
    layerTexts.push(labels.join(separator))
  }

  return layerTexts.join(' e ')
})

const timelineProps = computed(() => {
  const instance = detailedException.value?.approvalInstance
  if (!instance) return null
  return mapApprovalToTimeline({
    approvalInstance: instance,
    requestDate: detailedException.value!.requestDate,
    requesterName: detailedException.value!.requester.name
  })
})

const availableRoles = computed<ValidationRole[]>(
  () => detailedException.value?.availableRolesForCurrentUser ?? []
)

const selectedRole = ref<ValidationRole | null>(null)

const effectiveRole = computed<ValidationRole | undefined>(() => {
  if (availableRoles.value.length === 1) return availableRoles.value[0]
  return selectedRole.value ?? undefined
})

const canActOnApproval = computed(() => {
  if (!flags.enabledApprovalEngine || !detailedException.value?.approvalInstance) return true
  return availableRoles.value.length > 0
})

const canReproveException = computed(() => {
  if (flags.enabledApprovalEngine && detailedException.value?.approvalInstance) {
    return canActOnApproval.value
  }
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationExceptionalitiesReproving,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const canApproveException = computed(() => {
  if (flags.enabledApprovalEngine && detailedException.value?.approvalInstance) {
    return canActOnApproval.value
  }
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationExceptionalitiesApproving,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const approvedExceptionTitles = computed(() =>
  evaluationItems.value
    .filter((item) => item.approvalStatus === 'approved')
    .map((item) => item.title)
)

const rejectedExceptionTitles = computed(() =>
  evaluationItems.value
    .filter((item) => item.approvalStatus === 'rejected')
    .map((item) => item.title)
)

const formatHours = (decimalHours: string | number | null | undefined): string => {
  const num = Number(decimalHours)
  if (isNaN(num) || num < 0) {
    return '00:00'
  }

  const hours = Math.floor(num)
  const minutesFraction = num - hours
  const minutes = Math.round(minutesFraction * 60)

  const paddedHours = String(hours).padStart(2, '0')
  const paddedMinutes = String(minutes).padStart(2, '0')

  return `${paddedHours}:${paddedMinutes}`
}

watch(
  evaluationItems,
  (newItems) => {
    const statusMap: ApprovalStatusMap = {
      financials: null,
      repassMode: null,
      proportionalityRule: null,
      workJourney: null
    }

    newItems.forEach((item) => {
      if (item.id in statusMap) {
        const key = item.id as keyof ApprovalStatusMap
        if (item.approvalStatus === 'approved') {
          statusMap[key] = 'Approved'
        } else if (item.approvalStatus === 'rejected') {
          statusMap[key] = 'Rejected'
        } else {
          statusMap[key] = null
        }
      }
    })

    emit('status-map-changed', statusMap)
  },
  { deep: true }
)

watchEffect(async () => {
  if (!isSidebarOpen.value || !props.exceptionId) {
    resetState()
    return
  }

  if (detailedException.value?.id === props.exceptionId) {
    return
  }

  loading.value = true
  try {
    detailedException.value = await exceptionService.getDetails(props.exceptionId, props.scheduleId)
  } catch (error) {
    console.error('Failed to fetch exception details:', error)
    // Antes: literal fixo, descartando a mensagem do backend (404 do pedido, etc.).
    notifyError(error, 'Não foi possível carregar os detalhes da excepcionalidade.')
    detailedException.value = null
  } finally {
    loading.value = false
  }
})

watch(detailedException, (newException) => {
  if (!newException) {
    evaluationItems.value = []
    return
  }

  const e = newException

  const getWorkJourneyDetails = () => `
    <p><strong>Duração base:</strong> ${formatHours(e.financials.baseDurationHours)} horas</p>
    <p><strong>Duração excepcional:</strong> ${formatHours(
      e.financials.exceptionalDurationHours
    )} horas</p>
    <p><strong>Horas perdidas:</strong> ${formatHours(e.financials.lostHours)} horas</p>
    <p><strong>Valor de horas perdidas:</strong> ${formatCurrency(
      Number(e.financials.valueOfLostHours)
    )}</p>
  `

  evaluationItems.value = [
    {
      id: 'financials',
      title: 'Valor excepcional',
      icon: mdiLockOpenVariant,
      details: DOMPurify.sanitize(`
        <p><strong>Valor base:</strong> ${formatCurrency(
          Math.round(Number(e.financials.baseCost) * Number(e.financials.baseDurationHours))
        )}</p>
        <p><strong>Valor excepcional:</strong> ${formatCurrency(
          Number(e.financials.totalExceptionalValue)
        )}</p>
        <p><strong>Prejuízo previsto:</strong> <span class="text-red-600 font-semibold">${formatCurrency(Math.floor(Number(e.financials.estimatedLossTotal)))}</span></p>
      `),
      approvalStatus: null,
      analystJustification: ''
    },
    {
      id: 'repassMode',
      title: 'Modalidade de repasse',
      icon: mdiLockOpenVariant,
      details: DOMPurify.sanitize(
        `<p><strong>Original:</strong> ${formatRepassMode(
          e.changes.repassMode?.original
        )}</p><p><strong>Solicitado:</strong> ${formatRepassMode(e.changes.repassMode?.requested)}</p>`
      ),
      approvalStatus: null,
      analystJustification: ''
    },
    {
      id: 'proportionalityRule',
      title: 'Regra de proporcionalidade',
      icon: mdiLockOpenVariant,
      details: DOMPurify.sanitize(
        `<p><strong>Original:</strong> ${formatProportionalityRule(
          e.changes.proportionalityRule?.original
        )}</p><p><strong>Solicitado:</strong> ${formatProportionalityRule(
          e.changes.proportionalityRule?.requested
        )}</p>`
      ),
      approvalStatus: null,
      analystJustification: ''
    },
    {
      id: 'workJourney',
      title: 'Jornada de trabalho',
      icon: mdiLockOpenVariant,
      details: DOMPurify.sanitize(getWorkJourneyDetails()),
      approvalStatus: null,
      analystJustification: ''
    }
  ]
})

function openConfirmation(actionType: ModalActionType) {
  currentConfirmActionType.value = actionType
  isConfirmModalOpen.value = true
}

async function handleConfirmAction(action: ModalActionType) {
  isConfirmModalOpen.value = false
  await handleSubmit(action)
}

async function handleSubmit(action: ModalActionType) {
  if (!detailedException.value) {
    toast.error('Detalhes do pedido não disponíveis para submissão.')
    return
  }

  isSubmitting.value = true
  try {
    const isApproval = action === ModalActionType.APPROVE
    const targetStatus = isApproval ? 'approved' : 'rejected'
    const approverRole = detailedException.value.approvalInstance ? effectiveRole.value : undefined

    const justification = evaluationItems.value
      .filter((item) => item.approvalStatus === targetStatus && item.analystJustification)
      .map((item) => `${item.title}: ${item.analystJustification}`)
      .join('; ')

    const response = isApproval
      ? await exceptionService.approve(
          detailedException.value.id,
          justification,
          props.scheduleId,
          approverRole
        )
      : await exceptionService.reject(
          detailedException.value.id,
          justification,
          props.scheduleId,
          approverRole
        )

    const isStillInProgress = response.status === 'PENDING'
    if (isStillInProgress) {
      toast.success('Sua decisão foi registrada. Aguardando demais validadores.')
    } else {
      toast.success('Solicitação processada com sucesso!')
    }

    emit('submitSuccess')
    isSidebarOpen.value = false
  } catch (error: any) {
    console.error('[RequestExceptionalitySidebar] Submission error:', error)

    // Trava do Pós-Plantão: garante a frase certa mesmo quando o backend não
    // manda `message`, e mantém a sidebar aberta (o `isSidebarOpen = false` só
    // roda na trilha de sucesso).
    if (isPostStationApprovedError(error)) {
      toast.error(getPostStationApprovedMessage(error))
      return
    }

    // getApiErrorMessage cobre o ServiceError do service (que embrulha o erro
    // HTTP) e o shape axios cru — a extração manual de response.data.message
    // deixaria de funcionar com o erro normalizado.
    toast.error(getApiErrorMessage(error, 'Falha ao processar a solicitação.'))
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseSidebar, {
      modelValue: isSidebarOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isSidebarOpen).value = $event)),
      title: "Solicitação de excepcionalidade",
      description: "Acompanhe o andamento e os detalhes do pedido de excepcionalidade enviado para aprovação."
    }, _createSlots({
      footer: _withCtx(() => [
        (isAwaitingApproval.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              (
            !canActOnApproval.value && detailedException.value?.status === _unref(ExceptionStatusEnum).AWAITING_APPROVAL
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Você já registrou sua decisão neste fluxo ou não possui permissão para os papéis pendentes. "))
                : _createCommentVNode("", true),
              (availableRoles.value.length >= 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoles.value, (role) => {
                        return (_openBlock(), _createBlock(_component_v_chip, {
                          key: role,
                          variant: selectedRole.value === role ? 'flat' : 'outlined',
                          color: selectedRole.value === role ? 'primary' : undefined,
                          "data-testid": `role-selector-chip-${role}`,
                          onClick: ($event: any) => (selectedRole.value = role)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(VALIDATION_ROLE_LABELS)[role]), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant", "color", "data-testid", "onClick"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (canActOnApproval.value && !allAreApproved.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_52, " É necessário definir uma ação (Aprovar/Recusar) para todos os itens para prosseguir. "))
                : _createCommentVNode("", true),
              (canActOnApproval.value && _ctx.postStationLocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createVNode(SVGIcon, {
                      path: _unref(mdiLock),
                      class: "w-4 h-4 mt-0.5 shrink-0 text-primary30"
                    }, null, 8, ["path"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(POST_STATION_LOCK_BANNER_TEXT)), 1)
                  ]))
                : _createCommentVNode("", true),
              (canActOnApproval.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    (canReproveException.value)
                      ? (_openBlock(), _createBlock(FilledButton, {
                          key: 0,
                          text: "Recusar pedido",
                          width: "46%",
                          height: "48px",
                          class: "!bg-primary30",
                          loading: isSubmitting.value,
                          disabled: 
              isSubmitting.value || _ctx.postStationLocked || (availableRoles.value.length >= 2 && !effectiveRole.value)
            ,
                          "data-testid": "reject-exception-button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (openConfirmation(_unref(ModalActionType).REJECT)))
                        }, null, 8, ["loading", "disabled"]))
                      : _createCommentVNode("", true),
                    (canApproveException.value)
                      ? (_openBlock(), _createBlock(OutlinedButton, {
                          key: 1,
                          text: "Aprovar pedido",
                          width: "46%",
                          height: "48px",
                          class: "flex-grow !border-negative !text-negative !bg-white",
                          loading: isSubmitting.value,
                          disabled: 
              isSubmitting.value ||
              _ctx.postStationLocked ||
              !allAreApproved.value ||
              (availableRoles.value.length >= 2 && !effectiveRole.value)
            ,
                          "data-testid": "approve-exception-button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (openConfirmation(_unref(ModalActionType).APPROVE)))
                        }, null, 8, ["loading", "disabled"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "64"
              })
            ]))
          : (!detailedException.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(flags).enabledApprovalEngine && detailedException.value.approvalInstance)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (timelineProps.value)
                        ? (_openBlock(), _createBlock(ExceptionalityProgressTimeline, {
                            key: 0,
                            "header-status": timelineProps.value.headerStatus,
                            title: timelineProps.value.title,
                            layers: timelineProps.value.layers,
                            "base-event": timelineProps.value.baseEvent,
                            "data-testid": "request-exceptionality-progress-timeline"
                          }, null, 8, ["header-status", "title", "layers", "base-event"]))
                        : _createCommentVNode("", true),
                      _hoisted_6,
                      _createVNode(StatusBadge, {
                        status: detailedException.value.status,
                        "data-testid": "request-summary-status"
                      }, null, 8, ["status"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatDateTimeWithTimezone)(detailedException.value.requestDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("p", _hoisted_13, _toDisplayString(detailedException.value.requester.name), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("p", _hoisted_17, _toDisplayString(detailedException.value.approvalDate
                  ? _unref(formatDateTimeWithTimezone)(detailedException.value.approvalDate)
                  : 'Pendente'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("p", _hoisted_20, _toDisplayString(approvedApproversText.value || 'Nenhum até o momento'), 1)
                        ])
                      ]),
                      (pendingApproversText.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("p", _hoisted_23, _toDisplayString(pendingApproversText.value), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(formatDateToString)(new Date(detailedException.value.requestDate))), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("p", _hoisted_30, "#" + _toDisplayString(detailedException.value.id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(StatusBadge, {
                          status: detailedException.value.status,
                          class: "mt-1"
                        }, null, 8, ["status"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("p", _hoisted_35, _toDisplayString(detailedException.value.requester.name), 1)
                      ]),
                      (detailedException.value.evaluator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("p", _hoisted_38, _toDisplayString(detailedException.value.evaluator.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (detailedException.value.evaluationDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_unref(formatDateToString)(new Date(detailedException.value.evaluationDate))), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("p", _hoisted_44, _toDisplayString(detailedException.value.justification || 'Nenhuma justificativa fornecida.'), 1)
                ])
              ])),
        (detailedException.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluationItems.value, (item) => {
                return (_openBlock(), _createBlock(DropdownCard, {
                  key: item.id,
                  title: item.title,
                  icon: 
          item.approvalStatus === 'rejected' || item.approvalStatus === null ? _unref(mdiLock) : item.icon
        ,
                  "approval-status": item.approvalStatus,
                  "start-open": true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "text-sm flex flex-col gap-y-1 text-textPrimary text-left",
                      innerHTML: item.details
                    }, null, 8, _hoisted_46),
                    _createVNode(ApprovalChoice, {
                      modelValue: item.approvalStatus,
                      "onUpdate:modelValue": ($event: any) => ((item.approvalStatus) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(TextareaInput, {
                      modelValue: item.analystJustification,
                      "onUpdate:modelValue": ($event: any) => ((item.analystJustification) = $event),
                      placeholder: "Digite sua justificativa...",
                      rows: 4
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["title", "icon", "approval-status"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.stationContext)
        ? {
            name: "contextHeader",
            fn: _withCtx(() => [
              _createVNode(StationContextCard, _normalizeProps(_guardReactiveProps(_ctx.stationContext)), null, 16)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"]),
    (detailedException.value)
      ? (_openBlock(), _createBlock(ExceptionConfirmationSidebar, {
          key: 0,
          "is-open": isConfirmModalOpen.value,
          exception: detailedException.value,
          loading: isSubmitting.value,
          "action-type": currentConfirmActionType.value,
          "approved-exceptions": approvedExceptionTitles.value,
          "rejected-exceptions": rejectedExceptionTitles.value,
          "onUpdate:isOpen": _cache[3] || (_cache[3] = ($event: any) => (isConfirmModalOpen.value = $event)),
          onConfirmAction: handleConfirmAction
        }, null, 8, ["is-open", "exception", "loading", "action-type", "approved-exceptions", "rejected-exceptions"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})